export const getRootBonusApprovalsLink = () => {
  /* This is duplicated in the routes in app.js */
  return '/approvals/bonuses';
};


export const getBonusApprovalsLink = (userId, bonusMonth, supervisorId) => {
  const rootLink = getRootBonusApprovalsLink();
  const url = `${rootLink}/?userId=${userId}&bonusMonth=${bonusMonth}&supervisorId=${supervisorId}`;
  return url;
};
